import { render } from "./LeaderboardSection2.vue?vue&type=template&id=b5ba6c48"
import script from "./LeaderboardSection2.vue?vue&type=script&lang=js"
export * from "./LeaderboardSection2.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__